import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import type { FCWithChildren } from "../@types";
import { MCT_PORTAL_ROOT_ID } from "../config";

/**
 * Wraps a component in a portal if the `renderToPortal`argument is `true`
 * Uses a global root portal element, if it exists, otherwise `document.body`
 */
export const PortalWrapper: FCWithChildren<{ renderToPortal?: boolean }> = ({
  children,
  renderToPortal,
}) => {
  const [portalRoot, setPortalRoot] = useState<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!portalRoot) {
      const portalRootEl =
        document.querySelector(`#${MCT_PORTAL_ROOT_ID}`) ?? document.body;
      setPortalRoot(portalRootEl as HTMLDivElement);
    }
  }, [portalRoot]);
  return renderToPortal && portalRoot
    ? createPortal(children, portalRoot)
    : children;
};
